import React from 'react';
import ReactDOM from 'react-dom/client';
import 'mapbox-gl/dist/mapbox-gl.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';

import venueReducer from './redux/Venues';
import buildingReducer from './redux/Buildings'
import patchReducer from './redux/Patch'
import polylineReducer from './redux/Polyline'
import landmarksReducer from './redux/Landmarks';
import liftReducer from './redux/Lifts'

const store = configureStore({
  reducer: {
    venues: venueReducer,
    buildings: buildingReducer,
    patch: patchReducer,
    polyline: polylineReducer,
    landmarks: landmarksReducer,
    lifts: liftReducer
  }
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
